import { useGetDownloadUrl } from '../useGetDownloadUrl';
import { useGetSignedUrl } from '../useGetSignedUrl';

/**
 * Resolves a playback URL for a media asset, choosing the right transport for
 * the media type:
 * - Images go through the Cache API / blob path (`useGetDownloadUrl`) for
 *   offline-friendly reuse.
 * - Videos take the signed URL directly (`useGetSignedUrl`) so the browser can
 *   stream via HTTP byte-range requests instead of buffering the whole file
 *   into a `blob:` object URL.
 *
 * Both underlying hooks are always invoked to satisfy the rules of hooks; the
 * one that does not match `mediaType` is disabled by receiving `undefined`.
 */
export const useMediaUrl = (assetId?: string, mediaType: 'image' | 'video' = 'image') => {
  const isVideo = mediaType === 'video';
  const imageQuery = useGetDownloadUrl(isVideo ? undefined : assetId);
  const videoQuery = useGetSignedUrl(isVideo ? assetId : undefined);
  return isVideo ? videoQuery : imageQuery;
};
